"use client";

import { useEffect, type ReactElement } from "react";

type IframeModuleProps = {
    entryId: string;
    src: string;
    title: string;
};
export function IframeModuleView({
    src,
    title,
    entryId,
}: Readonly<IframeModuleProps>): ReactElement {
    useEffect(() => {
        const handleMessage = (e: MessageEvent) => {
            const iframe = document.querySelector<HTMLIFrameElement>(
                `#${CSS.escape(entryId)} iframe`,
            );

            if (!iframe) return; // Ensure iframe exists

            iframe.addEventListener("load", () => {
                window.top?.scrollTo(0, 0);
            });

            if (e.data && e.data.type === "setIframeHeight") {
                iframe.style.height = `${e.data.height}px`;
            }
        };

        window.addEventListener("message", handleMessage, false);

        // Cleanup function to remove event listener after component unmount
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [entryId]);

    return <iframe width="100%" height="400px" src={src} title={title} />;
}
